<template>
  <a-modal
    :title="title"
    :visible="visible"
    :width="850"
    @cancel="handleCancel"
  >
    <a-row>
      <a-col :span="24" class="mb_15">
        <span class="labelSpan">任务描述：</span>
        <a-input
          class="contentSpan"
          v-model="model.description"
          autocomplete="off"
          :disabled="true"
        />
      </a-col>
      <a-col :span="24" class="mb_15">
        <span class="labelSpan">执行频率：</span>
        <span class="contentSpan">
          <span>每&ensp;</span>
          <a-input-number v-model="model.dayNumber" :min="1" :max="maxDayNumber" style="width: 65px" @change="changeDayNumber"/>
          <span>&ensp;天，</span>
          <a-time-picker v-model="model.time" format="HH:mm" style="width: 105px" @change="changeTime"/>
          <span>&ensp;触发任务</span>
        </span>
      </a-col>
      <a-col :span="24" class="mb_15">
        <span class="labelSpan"></span>
        <span class="contentSpan">
          请以开始时间为月首，并按照计划时间，循环触发任务执行<br/>
          下次执行时间为，{{ model.nextExecutionTime }}
        </span>
      </a-col>
    </a-row>
    <template slot="footer">
      <a-button key="back" @click="handleCancel">
        取消
      </a-button>
      <a-button key="submit" :loading="loading" type="primary" @click="handleSubmit">
        保存
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment'
import { getNextExecution, timedTask } from '@/api/timingTask'

export default {
  name: 'ViewModules',
  data () {
    return {
      labelCol: { style: 'width: 100px' },
      wrapperCol: { style: 'width: calc(100% - 100px)' },
      title: '',
      type: '',
      model: {},
      form: this.$form.createForm(this, { name: 'proprietors' }),
      visible: false,
      loading: false,
      // 获取当前月份的最后一天
      maxDayNumber: Number(moment().endOf('month').format('DD'))
    }
  },
  created () {

  },
  methods: {
    setTitle (title) {
      this.title = title
    },
    setType (type) {
      this.type = type
    },
    setModel (model) {
      this.model = JSON.parse(JSON.stringify(model))
      this.model.time = moment(this.model.time, 'HH:mm')
    },
    open (visible) {
      this.visible = visible
    },
    handleCancel () {
      this.model = {}
      this.form.resetFields()
      this.visible = false
    },
    // 改变执行频率
    changeDayNumber (e) {
      console.log(Number(moment().endOf('month').format('DD')))
      this.getNextExecutionTime({
        dayNumber: e,
        time: this.model.time.format('HH:mm')
      })
    },
    // 改变执行时间
    changeTime (e) {
      this.getNextExecutionTime({
        dayNumber: this.model.dayNumber,
        time: e.format('HH:mm')
      })
    },
    // 获取下次执行时间
    getNextExecutionTime (params) {
      const data = {
        dayNumber: params.dayNumber,
        time: params.time
      }
      getNextExecution(data).then(res => {
        if (res.status === 0) {
          this.model.nextExecutionTime = res.data.nextExecutionTime
          this.model.cronExpression = res.data.cronExpression
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
        })
    },
    // 保存
    handleSubmit () {
      if (!this.model.dayNumber) {
        this.$message.error('请填写执行频率')
        return
      }
      if (!this.model.time) {
        this.$message.error('请填写执行时间')
        return
      }
      const params = {
        id: this.model.id,
        dayNumber: this.model.dayNumber,
        time: this.model.time.format('HH:mm'),
        description: this.model.description,
        cronExpression: this.model.cronExpression
      }
      this.loading = true
      timedTask(params).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.$emit('getTableData')
          this.handleCancel()
          this.loading = false
        } else {
          this.$message.error(res.info.message)
          this.loading = false
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
          this.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>

.mb_15 {
  margin-bottom: 15px;
}
.labelSpan {
  display: inline-block;
  width: 5rem;
  text-align: right;
}
.contentSpan {
  display: inline-block;
  width: calc(100% - 5rem);
}
</style>
